
<template>
  <div class="tab-height-div">
    <Spin fix v-if="isLoading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <Table border :columns="columns" :data="dataArr"></Table>
  </div>
</template>

<script>
export default {
  name: "FormWeb",
  data() {
    return {
        isLoading:true,
      arr: [
        { label: "文本框", value: 0 },
        { label: "密码", value: 1 },
        { label: "单选框", value: 2 },
        { label: "多选", value: 3 },
        { label: "日期(yyyy-MM-dd)", value: 4 },
        { label: "日期(yyyy-MM-dd HH:mm:ss)", value: 5 },
        { label: "多行文本", value: 8 },
        { label: "下拉框", value: 9 }
      ],
      compareArr: [
        { label: "=", value: 0 },
        { label: ">=", value: 1 },
        { label: "<=", value: 2 },
        { label: "like", value: 3 }
      ],
      columns: [
        {
          title: "字段名称",
          key: "name",
          filteredValue: [null],
          filterMethod(value, row) {
            return row.fieldName.trim().length !== 0;
          },
          render: (h, params) => {
            return h("Input", {
              props: {
                value: params.row.fieldName,
                disabled: true
              }
            });
          }
        },
        {
          title: "字段备注",
          key: "marker",
          render: (h, params) => {
            return h("Input", {
              props: {
                value: params.row.content,
                disabled: true
              }
            });
          }
        },
        {
          title: "表单显示",
          align: "center",
          width: 120,
          key: "formShow",
          render: (h, params) => {
            return h("Checkbox", {
              props: {
                value: params.row.isShow
              },
              on: {
                "on-change": event => {
                  this.dataArr[params.index].isShow = event;
                  // this.typeChange(params.index);
                }
              }
            });
          }
        },
        {
          title: "列表显示",
          align: "center",
          width: 120,
          key: "listShow",
          render: (h, params) => {
            return h("Checkbox", {
              props: {
                value: params.row.isShowList
              },
              on: {
                "on-change": event => {
                  this.dataArr[params.index].isShowList = event;
                  // this.typeChange(params.index);
                }
              }
            });
          }
        },
        {
          title: "控件类型",
          width: 250,
          key: "type",
          render: (h, params) => {
            return h(
              "div",
              {
                class:
                  (params.row["isQuery"] || params.row["isShow"]) &&
                  (!params.row["showType"] && !(params.row["showType"] == "0"))
                    ? "ctName"
                    : ""
              },
              [
                h(
                  "Select",
                  {
                    props: {
                      transfer: true,
                      value: params.row.showType
                    },
                    style: {
                      width: "200px"
                    },
                    class: "ctinpt",
                    on: {
                      "on-change": event => {
                        this.dataArr[params.index].showType = event;
                        // this.typeChange(params.index);
                      }
                    }
                  },
                  this.arr.map(item => {
                    return h("Option", {
                      props: {
                        value: item.value,
                        label: item.label
                      }
                    });
                  })
                ),
                h(
                  "div",
                  {
                    style: {
                      color: "red",
                      display:
                        (params.row["isQuery"] || params.row["isShow"]) &&
                        (!params.row["showType"] &&
                          !(params.row["showType"] == "0"))
                          ? "inline-block"
                          : "none"
                    },
                    class: "cxnameselect"
                  },
                  [
                    h("Icon", {
                      props: {
                        type: "ios-alert"
                      }
                    }),
                    h("Font", { style: { color: "red" } }, "控件类型必选")
                  ]
                )
              ]
            );
          }
        },
        {
          title: "控件长度",
          key: "length",
          render: (h, params) => {
            return h("Input", {
              props: {
                value: params.row.fieldLength
              },
              on: {
                "on-blur": event => {
                  this.dataArr[params.index].fieldLength = event.target.value;
                }
              }
            });
          }
        },
        {
          title: "是否查询",
          width: 120,
          align: "center",
          key: "query",
          render: (h, params) => {
            return h("Checkbox", {
              props: {
                value: params.row.isQuery
              },
              on: {
                "on-change": event => {
                  this.dataArr[params.index].isQuery = event;
                  // this.typeChange(params.index);
                }
              }
            });
          }
        },
        {
          title: "查询类型",
          width: 200,
          key: "queryType",
          render: (h, params) => {
            return h(
              "div",
              {
                class:
                  params.row["isQuery"] &&
                  (!params.row["queryMode"] &&
                    !(params.row["queryMode"] == "0"))
                    ? "ctName"
                    : ""
              },
              [
                h(
                  "Select",
                  {
                    props: {
                      transfer: true,
                      value: params.row.queryMode,
                      clearable: true
                    },
                    style: {
                      width: "100px"
                    },
                    class: "ctinpt",
                    on: {
                      "on-change": event => {
                        this.dataArr[params.index].queryMode = event;
                        // this.typeChange(params.index);
                      }
                    }
                  },
                  this.compareArr.map(item => {
                    return h("Option", {
                      props: {
                        value: item.value,
                        label: item.label
                      }
                    });
                  })
                ),
                h(
                  "div",
                  {
                    style: {
                      color: "red",
                      display:
                        params.row["isQuery"] &&
                        (!params.row["queryMode"] &&
                          !(params.row["queryMode"] == "0"))
                          ? "inline-block"
                          : "none"
                    },
                    class: "cxnameselect"
                  },
                  [
                    h("Icon", {
                      props: {
                        type: "ios-alert"
                      }
                    }),
                    h("Font", { style: { color: "red" } }, "查询类型必选")
                  ]
                )
              ]
            );
          }
        }
      ],
      dataArr: []
    };
  },
  props: {
    // dataArr: Array,
    isWeb: {}
  },
  computed: {
    currentData() {
      return this.$store.state.tabdata.info;
    }
  },
  methods: {
    // getData() {
    //   if (this.isWeb) {
    //     this.dataArr = this.$store.state.tabdata.dataArr;
    //   }
    // }
  },
  watch: {
    currentData(v) {
      setTimeout(() => {
        this.dataArr = this.$store.state.tabdata.info;
      }, 200);
    }
  },
  mounted() {
    // console.log(this.dataArr,'123')
    // console.log("3", this.$store.state.tabdata.dataArr);
    // this.dataArr = this.$store.state.tabdata.dataArr;
    // this.getData();
  }
};
</script>

<style scoped>
.tab-height-div {
  height: calc(100vh - 180px);
  overflow: auto;
}
.ctName {
  height: 115px;
  position: relative;
}
.ctName .ctinpt {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.ctName .cxname {
  position: absolute;
  bottom: 3px;
}

 .cxnameselect {
  position: absolute;
  bottom: 21px;
}
</style>
